import { BROKERS_STORAGE_KEYS } from '@/lib/localStorageKeys/brokers';
import { Broker } from './types';
import {
  writeCache,
  BROKERS_CACHE_MAX_BYTES,
} from '@/lib/storage/safeLocalStorage';

export const getStoredBrokers = (): Broker[] => {
  if (typeof window === 'undefined') {
    return [];
  }

  try {
    const storedData = localStorage.getItem(BROKERS_STORAGE_KEYS.CORE);
    
    if (!storedData) {
      return [];
    }

    const parsedData = JSON.parse(storedData);
    
    if (!Array.isArray(parsedData)) {
      console.error('Invalid brokers data in localStorage');
      return [];
    }

    return parsedData.map((broker) => ({
      ...broker,
      providerKind: broker.providerKind ?? "T5",
    }));
  } catch (error) {
    console.error('Error loading brokers from localStorage:', error);
    return [];
  }
};

export const saveBrokers = (brokers: Broker[]): void => {
  if (typeof window === 'undefined') {
    return;
  }

  // Warm-start cache only — `fetchBrokers()` re-pulls the catalog on every boot, so this must never
  // cost an essential write its space. On this install it had grown to ~4 MB (4,559 MT5 servers) and
  // filled the origin's entire quota.
  writeCache(
    BROKERS_STORAGE_KEYS.CORE,
    JSON.stringify(brokers),
    BROKERS_CACHE_MAX_BYTES
  );
};

export const clearStoredBrokers = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(BROKERS_STORAGE_KEYS.CORE);
  } catch (error) {
    console.error('Error clearing brokers from localStorage:', error);
  }
};

/**
 * Get the size of stored brokers in bytes
 * @returns Size in bytes or 0 if not found
 */
export function getStoredBrokersValue(): number {
  if (typeof window === 'undefined') return 0;
  
  try {
    const stored = localStorage.getItem(BROKERS_STORAGE_KEYS.CORE);
    
    if (!stored) return 0;
    
    // Calculate size in bytes (JavaScript strings are UTF-16, so each character is 2 bytes)
    return stored.length * 2;
  } catch (error) {
    console.error('Error getting brokers size:', error);
    return 0;
  }
}